import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import classnames from 'classnames';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import {
  Intl, ContactModal, AudioModal, ConfirmationModal, CountryLabel,
} from 'components';
import { formatNumeral } from 'utils';


const chartOrder = {
  PRESSED: 0,
  LISTENED: 1,
  FAREWELLLISTENED: 2,
  OPTIONLISTENED: 3,
  INTROLISTENED: 4,
  HANGUP: 5,
  REJECTED: 6,
  IGNORED: 7,
  COMMUNICATING: 8,
  ERROR: 9,
  NONEXISTENT: 10,
};

const orderChartData = (chartData) => chartData.sort(
  (a, b) => (chartOrder[a.id.toUpperCase()] < chartOrder[b.id.toUpperCase()] ? -1 : 1),
);

const ItemRow = ({ title, info, values = {}, }) => (
  <Row style={{ marginBottom: 2 }}>
    <Col
      md={3}
      style={{ borderRight: '2px solid white' }}
      className="bg-gray-3 py-1 font-weight-bold text-sm"
    >
      <Intl id={title} values={values} />
    </Col>
    <Col md className="bg-mp-gray-3 py-1 text-sm d-flex">{info}</Col>
  </Row>
);

const RenderAudios = React.memo(({ data, toggleAudioModal }) => {

  if (!_.get(data, 'configData.audios')) {
    return null;
  }

  const uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
  if (data.type === 'simple_message') {
    return (
      <>
        {data.type ? <Intl id={data.type} /> : ''}
        {': '}
        {data.type === 'simple_message' && (
          <div
            data-tip="simple_message"
            // style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}
            data-for={`action_${uid}_2`}
          >&nbsp;
            <Button
              color="outline-link"
              className="p-0"
              data-tip={
                data.configData.audios.message_audio
                  && data.configData.audios.message_audio.name
                  ? data.configData.audios.message_audio.name
                  : 'Audio1'
              }
              data-for={`action_${uid}_2`}
              onClick={() => data.configData.audios.message_audio
                && data.configData.audios.message_audio.name ? toggleAudioModal('audioVoiceName', _.get(data, 'configData.audios.message_audio.uri'), data.configData.audios.message_audio.name) : toggleAudioModal('introduction', _.get(data, 'configData.audios.message_audio.uri'))}
            >
              {data.configData.audios.message_audio
                && data.configData.audios.message_audio.name
                ? data.configData.audios.message_audio.name
                : 'Audio1'}
            </Button>
          </div>
        )}
        <ReactTooltip
          id={`action_${uid}_2`}
          place="bottom"
          aria-haspopup="true"
          getContent={(dataTip) => (dataTip === 'simple_message' ? (
            <Intl id="simple_message" />
          ) : (
            `${dataTip}`
          ))}
        />
      </>
    )
  }

  return (
    <>

      {data.type ? <Intl id={data.type} /> : ''}
      {': '}
      {data.type === 'poll' && (
        <div
          // style={{ width: '100%', textAlign: 'left', paddingLeft: '15px' }}
          data-tip="survey"
          data-for={`action_${uid}_2`}
        >
          &nbsp;
          <Button
            color="outline-link"
            className="p-0"
            data-tip={
              data.configData.audios.intro_audio
                && data.configData.audios.intro_audio.name
                ? data.configData.audios.intro_audio.name
                : 'introduction'
            }
            data-for={`action_${uid}_2`}
            // onClick={() => toggleAudioModal( 'introduction', _.get( data, 'configData.audios.intro_audio.uri' ) )}
            onClick={() => data.configData.audios.intro_audio && data.configData.audios.intro_audio.name ? toggleAudioModal('audioVoiceName', _.get(data, 'configData.audios.intro_audio.uri'), data.configData.audios.intro_audio.name) : toggleAudioModal('introduction', _.get(data, 'configData.audios.intro_audio.uri'))}
          >
            {data.configData.audios.intro_audio
              && data.configData.audios.intro_audio.name ? (
              `${data.configData.audios.intro_audio.name.slice(0, 25)}...`
            ) : (
              <Intl id="introduction" />
            )}
            {/* <Intl id="introduction" /> */}
          </Button>
          |
          <Button
            color="outline-link"
            className="p-0"
            data-tip={
              data.configData.audios.question_audio
                && data.configData.audios.question_audio.name
                ? data.configData.audios.question_audio.name
                : 'options'
            }
            data-for={`action_${uid}_2`}
            // onClick={() => toggleAudioModal( 'options', _.get( data, 'configData.audios.question_audio.uri' ) )}
            onClick={() => data.configData.audios.question_audio && data.configData.audios.question_audio.name ? toggleAudioModal('audioVoiceName', _.get(data, 'configData.audios.question_audio.uri'), data.configData.audios.question_audio.name) : toggleAudioModal('introduction', _.get(data, 'configData.audios.question_audio.uri'))}
          >
            {data.configData.audios.question_audio
              && data.configData.audios.question_audio.name ? (
              `${data.configData.audios.question_audio.name.slice(0, 25)}...`
            ) : (
              <Intl id="options" />
            )}
            {/* <Intl id="options" /> */}
          </Button>
          |
          <Button
            color="outline-link"
            className="p-0"
            data-tip={
              data.configData.audios.closing_audio
                && data.configData.audios.closing_audio.name
                ? data.configData.audios.closing_audio.name
                : 'farewell'
            }
            data-for={`action_${uid}_2`}
            // onClick={() => toggleAudioModal( 'farewell', _.get( data, 'configData.audios.closing_audio.uri' ) )}
            onClick={() => data.configData.audios.closing_audio && data.configData.audios.closing_audio.name ? toggleAudioModal('audioVoiceName', _.get(data, 'configData.audios.closing_audio.uri'), data.configData.audios.closing_audio.name) : toggleAudioModal('introduction', _.get(data, 'configData.audios.closing_audio.uri'))}
          >
            {data.configData.audios.closing_audio
              && data.configData.audios.closing_audio.name ? (
              ` ${data.configData.audios.closing_audio.name.slice(0, 25)}...`
            ) : (
              <Intl id="farewell" />
            )}
            {/* <Intl id="farewell" /> */}
          </Button>
        </div>
      )}
      <ReactTooltip
        id={`action_${uid}_2`}
        place="bottom"
        aria-haspopup="true"
        getContent={(dataTip) => (dataTip === 'survey' ? (
          <Intl id="survey" />
        ) : dataTip === 'introduction' ? (
          <Intl id="introduction" />
        ) : dataTip === 'options' ? (
          <Intl id="options" />
        ) : dataTip === 'farewell' ? (
          <Intl id="farewell" />
        ) : (
          `${dataTip}`
        ))}
      />
    </>
  );
});

export default ({
  data, chartData, chartKeyData, isLoading, onExport, onDelete, onChangeStatus, userData,
}) => {
  const [isInitialMountState, setInitialState] = useState(true);
  const [contactModal, setContactModal] = useState(false);
  const [audioModal, setAudioModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const audioRef = useRef({});
  const confirmationActionRef = useRef(null);
  const confirmationTitleRef = useRef(null);
  const chartRef = useRef();
  const chartKeyRef = useRef();

  const toggleContactModal = useCallback(() => {
    setContactModal((state) => !state);
  }, []);

  const toggleConfirmationModal = useCallback((title, action) => {
    confirmationTitleRef.current = title;
    confirmationActionRef.current = action;
    setConfirmationModal((state) => !state);
  }, []);

  const toggleAudioModal = useCallback((type, audio, values) => {
    audioRef.current = { type, audio, values };
    setAudioModal((state) => !state);
  }, []);

  useEffect(() => {
    if (isInitialMountState) {
      setInitialState(false);
    } else {
      am4core.addLicense('CH63305913');
      am4core.options.commercialLicense = true;
      chartRef.current = am4core.create('chartdiv', am4charts.PieChart);
      chartRef.current.data = orderChartData(chartData);
      const pieSeries = chartRef.current.series.push(new am4charts.PieSeries());
      // pieSeries.radius = am4core.percent( 140 );
      pieSeries.dataFields.value = 'people';
      pieSeries.dataFields.category = 'action';
      pieSeries.slices.template.propertyFields.fill = 'color';
      pieSeries.tooltip.fontSize = '12px';
      pieSeries.fontSize = '12px';
      pieSeries.slices.template.stroke = am4core.color('#fff');
      pieSeries.slices.template.strokeWidth = 2;

      pieSeries.slices.template.events.on('hit', (ev) => {
        onExport(ev.target.dataItem.dataContext);
      });

      chartKeyRef.current = am4core.create('chartdiv2', am4charts.PieChart);
      chartKeyRef.current.data = chartKeyData;
      const pieSeries2 = chartKeyRef.current.series.push(new am4charts.PieSeries());
      pieSeries2.dataFields.value = 'people';
      pieSeries2.dataFields.category = 'action';
      pieSeries2.slices.template.propertyFields.fill = 'color';
      pieSeries2.tooltip.fontSize = '12px';
      pieSeries2.fontSize = '12px';
      pieSeries2.slices.template.stroke = am4core.color('#fff');
      pieSeries2.slices.template.strokeWidth = 2;

      pieSeries2.slices.template.events.on('hit', (ev) => {
        onExport(ev.target.dataItem.dataContext);
      });

      return () => {
        if (chartRef.current) chartRef.current.dispose();
        if (chartKeyRef.current) chartKeyRef.current.dispose();
      };
    }
  }, [isInitialMountState]); //eslint-disable-line

  useEffect(() => {
    if (chartRef.current) chartRef.current.data = orderChartData(chartData);
  }, [chartData]);

  useEffect(() => {
    if (chartKeyRef.current) chartKeyRef.current.data = chartKeyData;
  }, [chartKeyData]);

  const status = useMemo(() => {
    switch (data.status) {
      case 'stopped':
      case 'cancelled':
      case 'finished':
        return data.status;
      case 'pending':
      case 'execution':
        return 'execution';
      default:
        return 'scheduled';
    }
  }, [data.status]);

  const [btnTitle, btnAction] = useMemo(() => {
    switch (data.status) {
      case 'stopped':
      case 'cancelled':
      case 'finished':
        return ['deleteCampaign', onDelete];
      case 'pending':
      case 'execution':
        return ['stopCampaign', () => onChangeStatus('stopped')];
      default:
        return ['cancelCampaign', () => onChangeStatus('cancelled')];
    }
  }, [data.status, onChangeStatus, onDelete]);

  return (
    <Container
      fluid
      className={classnames('pt-4', { 'app-component-loading': isLoading })}
    >
      <Row className="align-items-center mb-2">
        <Col className="pl-0 font-weight-bold">
          <Intl id="status" />
          {': '}
          <span className="text-mp-orange-1">{data.id ? <Intl id={status} /> : ''} ({data.callPercent}%)</span>
        </Col>
        {data.id && data.status !== 'execution' && data.status !== 'pending'
          && (
            <Col className="text-md-right pr-0">
              <Button
                color="app-default"
                size="app-sm"
                onClick={() => toggleConfirmationModal(btnTitle, btnAction)}
              >
                <Intl id={btnTitle} />
              </Button>
            </Col>
          )}
      </Row>
      <ItemRow
        title="campaign"
        info={data.name}
      />
      <ItemRow
        title="user"
        info={`${_.get(data, 'createdBy.firstName', '')} ${_.get(data, 'createdBy.lastName', '')}`}
      />
      <ItemRow
        title="where"
        info={(
          <>
            <CountryLabel country={data.country} />
            {_.get(data, 'voIp.codePhone') ? ` (+${data.voIp.codePhone})` : ''}
            {data.timeZone ? ` | ${data.timeZone}` : ''}
          </>
        )}
      />
      <ItemRow
        title="when"
        info={(
          <>
            {data.startDateTimeUtc
              ? (
                <span>
                  <Intl id="scheduled" />
                  {': '}
                  {moment.tz(moment(Number(data.startDateTimeUtc)), 'YYYY-MM-DD HH:mm', true, data.timeZone).format('YYYY-MM-DD HH:mm')}
                </span>
              ) : ''}
            {data.startedAt
              ? (
                <span>
                  {' | '}
                  <Intl id="began" />
                  {': '}
                  {moment.tz(moment(Number(data.startedAt)), 'YYYY-MM-DD HH:mm', true, data.timeZone).format('YYYY-MM-DD HH:mm')}
                </span>
              )
              : ''}
            {data.closedAt
              ? (
                <span>
                  {' | '}
                  <Intl id="finished" />
                  {': '}
                  {moment.tz(moment(Number(data.closedAt)), 'YYYY-MM-DD HH:mm', true, data.timeZone).format('YYYY-MM-DD HH:mm')}
                </span>
              )
              : ''}
          </>
        )}
      />
      <ItemRow
        title="what"
        info={<RenderAudios data={data} toggleAudioModal={toggleAudioModal} />}
      />
      <ItemRow
        title="who"
        info={(
          data.id
            ? (
              <>
                {/* {_.get( data, 'listPhoneNumbers[0].total', 0 )}
                {' '}
                <span className="text-lowercase"><Intl id="phones" /></span> */}
                {_.get(data, 'listPhoneNumbers[0].total') ? (
                  <>
                    {/* {' | '} */}
                    <Button
                      color="outline-link"
                      className="p-0"
                      onClick={toggleContactModal}
                    >
                      {_.get(data, 'listPhoneNumbers[0].total', 0)}
                      {' '}
                      <span className="text-lowercase"><Intl id="phones" /></span>
                    </Button>
                    {/* <Button
                      color="outline-link"
                      className="p-0"
                      onClick={toggleContactModal}
                    >
                      <Intl id="list" />
                    </Button> */}
                  </>
                ) :
                  <>
                    {_.get(data, 'listPhoneNumbers[0].total', 0)}
                    {' '}
                    <span className="text-lowercase"><Intl id="phones" /></span>
                  </>
                }
              </>
            ) : ''
        )}
      />
      <ItemRow
        title="costCurrency"
        values={{ currency: "(" + userData.currency_symbol + ")" }}
        info={(
          <>
            {data.cost ? formatNumeral(data.cost) : ''}
          </>
        )}
      />

      {data.status === 'finished' || data.status === 'execution' ? (
        <Row>
          <Col className="text-right text-sm pr-0">
            <Button
              color="outline-link"
              className="p-0"
              onClick={onExport}
            >
              <Intl id="downloadGlobalResult" />
            </Button>
            {' '}
            <Intl id="clickSectorsToDownload" />
          </Col>
        </Row>
      ) : null}

      <Row className="mt-5">
        <Col
          // md={!data.id || data.type === 'simple_message' || !chartKeyData.length ? 12 : 6}
          md={chartKeyData.length === 0 || data.type === 'simple_message' ? 12 : 6}
          className={classnames({
            'd-none': !chartData.length,
          })}
        >
          <div className="chartdiv-container">
            <div id="chartdiv" style={{ width: '100%', height: '220px' }} />
            {/* <div className="chartdiv-brand-eraser" /> */}
          </div>
        </Col>

        <Col
          md={6}
          className={classnames({
            'd-none': !chartKeyData.length,
          })}
        >
          <div className="chartdiv-container">
            <div id="chartdiv2" style={{ width: '100%', height: '220px' }} />
            {/* <div className="chartdiv-brand-eraser" /> */}
          </div>
        </Col>
      </Row>
      <div className="text-center pt-4">
        <Link to="/out/campaigns" className="font-weight-700 btn btn-app-default btn-app-sm">
          <Intl id="okBtn" />
        </Link>
      </div>


      {contactModal
        && (
          <ContactModal
            modalTitle="phoneNumbersList"
            data={_.get(data, 'listPhoneNumbers[0].phoneNumbers', [])}
            downloadId={_.get(data, 'listPhoneNumbers[0].id')}
            open={contactModal}
            onClose={toggleContactModal}
          />
        )}

      {audioModal
        && (
          <AudioModal
            uri={audioRef.current.audio}
            modalTitle={audioRef.current.type}
            values={audioRef.current.values}
            open={audioModal}
            translateTitle
            download
            onClose={toggleAudioModal}
          />
        )}

      <ConfirmationModal
        open={confirmationModal}
        title={`${confirmationTitleRef.current}Confirm`}
        onConfirm={confirmationActionRef.current ? () => {
          confirmationActionRef.current();
          toggleConfirmationModal();
        } : () => { }}
        onClose={toggleConfirmationModal}
      />
    </Container>
  );
};
